<template>
  <b-input-group>
    <b-form-input
      :id="id"
      :key="id"
      :type="inputType"
      :maxlength="maxlength"
      :placeholder="placeholder"
      @input="$emit('password-value-input', password)"
      v-model="password"
      :state="state"
      trim
    ></b-form-input>
    <b-input-group-append>
      <span
        class="input-group-text bg-white text-primary password-toggle"
        @click="togglePasswordReveal"
      >
        <i
          :class="passwordIconClass"
          id="toggle-show-pw"
          aria-hidden="true"
        ></i>
      </span>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
  name: 'PasswordField',
  props: ['id', 'maxlength', 'placeholder', 'state'],
  data: function () {
    return {
      inputType: 'password',
      password: '',
    };
  },

  computed: {
    formGroupId: function () {
      return this.id + '-group';
    },
    passwordIconClass: function () {
      return {
        fa: true,
        'text-form-accent': true,
        'fa-eye': this.inputType == 'password' ? true : false,
        'fa-eye-slash': this.inputType == 'text' ? true : false,
      };
    },
  },

  methods: {
    togglePasswordReveal: function () {
      this.inputType = this.inputType == 'password' ? 'text' : 'password';
    },
  },
};
</script>

<style>
</style>